export const HearFromUs = [
	{
		name: 'Search Engine',
		code: 'Search Engine',
	},
	{
		name: 'Google Ads',
		code: 'Google Ads',
	},
	{
		name: 'Facebook Ads',
		code: 'Facebook Ads',
	},
	{
		name: 'Youtube Ads',
		code: 'Youtube Ads',
	},
	{
		name: 'Other paid social media advertising',
		code: 'Other paid social media advertising',
	},
	{
		name: 'Other paid social media advertising',
		code: 'Other paid social media advertising',
	},
	{
		name: 'Facebook post/group',
		code: 'Facebook post/group',
	},
	{
		name: 'Twitter post',
		code: 'Twitter post',
	},
	{
		name: 'Instagram post/story',
		code: 'Instagram post/story',
	},
	{
		name: 'Other social media',
		code: 'Other social media',
	},
	{
		name: 'Email',
		code: 'Email',
	},
	{
		name: 'Radio',
		code: 'Radio',
	},
	{
		name: 'TV',
		code: 'TV',
	},
	{
		name: 'Newspaper',
		code: 'Newspaper',
	},
	{
		name: 'Word of mouth',
		code: 'Word of mouth',
	},
];
